import React from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
const Channelimg = 'https://fnicdn.blob.core.windows.net/regionh/stock/drainage_channel.jpg';

export default function Links() {
    return (
        <div>

            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row ps-lg-4'>
                        <h3>Links</h3>
                        <div className='col-lg-8'>
                            <div className='ms-2'>
                                <h5>RIVER AUTHORITIES</h5>
                                <ul>
                                    <li><a href="http://www.sjra.net/" target="_blank">San Jacinto River Authority</a></li>
                                    <li><a href="http://www.trinityra.org/" target="_blank">Trinity River Authority</a></li>
                                    <li><a href="http://www.brazos.org/" target="_blank">Brazos River Authority</a></li>
                                    <li><a href="https://lnva.dst.tx.us/" target="_blank">Lower Neches Valley Authority</a></li>
                                </ul>
                                <h5>SUBSIDENCE DISTRICTS</h5>
                                <ul>
                                    <li><a href="http://www.fbsubsidence.org/" target="_blank">Fort Bend Subsidence District</a></li>
                                    <li><a href="http://www.hgsubsidence.org/" target="_blank">Harris-Galveston Subsidence District</a></li>
                                </ul>
                                <h5>GROUNDWATER  CONSERVATION DISTRICTS</h5>
                                <ul><li><a href="http://www.bluebonnetgroundwater.org/" target="_blank">Bluebonnet Groundwater Conservation District</a>
                                </li>
                                    <li><a href="http://www.bcgroundwater.org/" target="_blank">Brazoria County Groundwater Conservation District</a></li>
                                    <li><a href="http://www.lonestargcd.org/" target="_blank">Lone Star Groundwater Conservation District </a></li>
                                    <li><a href="https://www.waterwells.info/" target="_blank">Lower Trinity Groundwater Conservation District</a></li>
                                    <li><a href="http://www.mideasttexasgcd.com/" target="_blank">Mid-East Texas Groundwater Conservation District</a></li>
                                </ul>
                                <h5>STATE AGENCIES</h5>
                                <ul>
                                    <li><a href="https://www.twdb.texas.gov/" target="_blank">Texas Water Development Board</a></li>
                                    <li><a href="https://www.tceq.texas.gov/" target="_blank">Texas Commission on Environmental Quality</a>
                                        <ul style={{ marginTop: "0", marginBottom: "0" }}>
                                            <li><a href="https://www.tceq.texas.gov/permitting/water_rights/wr_technical-resources/eflows" target="_blank">Environmental Flows</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="http://www.tpwd.state.tx.us/" target="_blank">Texas Parks &amp; Wildlife Department</a></li>
                                </ul>
                                <h5>NEIGHBORING REGIONS</h5>
                                <ul>
                                    <li><a href="http://www.regioncwater.org/" target="_blank">Region C</a></li>
                                    <li><a href="http://www.brazosgwater.org/" target="_blank">Brazos G</a></li>
                                    <li><a href="http://www.etexwaterplan.org/" target="_blank">East Texas (I)</a></li>
                                    <li><a href="http://www.regionk.org" target="_blank">Lower Colorado (K)</a></li>
                                </ul>
                                <h5>CONSERVATION LINKS</h5>
                                <ul>
                                    <li><a href="http://www.wateriq.org/" target="_blank">Water IQ</a></li>
                                    <li><a href="http://texaswater.tamu.edu/" target="_blank">Texas  Water Resources Education</a></li>
                                    <li><a href="http://tx.usgs.gov/" target="_blank">USGS</a></li>
                                </ul>
                            </div>


                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className="card" style={{ backgroundColor: "#f2f2f2" }} >
                                <img src={Channelimg} className="card-img-top p-2" />
                            </div>
                        </div>

                    </div>
                </div>
            </main>

        </div>
    )
}
